import axios from "axios";
import { supabase, SUPABASE_URL, SUPABASE_KEY } from './supabase';

export const API = `${SUPABASE_URL}/functions/v1/greatwall-api`;

export const api = axios.create({
  baseURL: API,
});

// Public routes must not inherit an expired session from the admin panel.
export const publicApi = axios.create({
  baseURL: API,
});
api.interceptors.request.use(async (config) => {
  const { data: { session } } = await supabase.auth.getSession();
  config.headers.apikey = SUPABASE_KEY;
  config.headers.Authorization = `Bearer ${session?.access_token || SUPABASE_KEY}`;
  return config;
});

export const fileUrl = (storage_path) =>
  storage_path ? supabase.storage.from('product-images').getPublicUrl(storage_path).data.publicUrl : "";

export const PLACEHOLDER_IMG =
  "/assets/c2254702a6f6d725.jpg";
